import React, { Fragment, useCallback } from 'react';
import cx from 'classnames';
import styles from './TWIABuildingStepper.module.scss';
import { Icon, useModal } from '@jutro/components';
import messages from '../../pages/BuildingsAndLocations/BuildingsAndLocationsPage.messages.js'
import { messages as commonMessages } from '@xengage/gw-platform-translations';

function TWIABuildingStepper(props) {
    const { submissionVM, updateWizardData, steps, currentIndex, setWizardStep } = props;
    const { showConfirm } = useModal();

    const checkIfTransitionAllowed = useCallback((targetStep) => {
        return currentIndex > targetStep;
    }, [currentIndex])
        
    const handleListClick = useCallback((step) => {
        if(!checkIfTransitionAllowed(step)){
            return
        }

        if(step === 1) {
            _.set(submissionVM, 'isAddBuilding', false);
        }

        setWizardStep(step)
    }, [checkIfTransitionAllowed])

    return (
        <div className={styles["twia-building-wizard"]}>
            {
                steps.map((step, index) => {
                    return  (
                        <Fragment key={index}>
                            { index > 0 && <div className={styles['step-separator']}/>}
                            <div className={cx(styles['wizard-step'], {
                                        [styles['gw-disabled']]: index > currentIndex
                            })}>
                                <div
                                    key={index}
                                    onClick={() => handleListClick(index)}
                                    className={cx(styles['wizard-step-number'], {
                                        [styles['gw-visited']]: index < currentIndex
                                    })}
                                >
                                    {index < currentIndex && <Icon icon="mi-check"/>}
                                    {index >= currentIndex && index + 1}
                                </div>
                                <span className={cx(styles['wizard-step-title'], {
                                    [styles['gw-current']]: index === currentIndex
                                })}>{step.title}</span>
                            </div>
                        </Fragment>
                    )
                })
            }
        </div>
    )
}

export default TWIABuildingStepper
